// extracted by mini-css-extract-plugin
module.exports = {"wrap":"s_wrap__Z-FiM"};